import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, message} from 'antd';
import { ChangeEmail } from '../api/ChangeEmail';

interface ChangeEmailModalProps {
    visible: boolean;
    usermail?: string
    onCancel: () => void;
    onSetUserMail: (usermail: string) => void;
  }
  
const ChangeEmailModal: React.FC<ChangeEmailModalProps> = ({ visible, usermail, onCancel, onSetUserMail }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ emailAddress: usermail });
  }, [usermail, form]);
  
  const onFinish = (changeemail: any) => {

    ChangeEmail(changeemail)
        .then((resetresponse) => {
          if (resetresponse.success)
          {
            onSetUserMail(changeemail.emailAddress)
            message.success("Successfully changed email address")
          }
          else{
            message.error(resetresponse.msg)
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error.message);
          return
        });   
    
    form.resetFields();  
    onCancel();  
  };

  return (
    <Modal
      open={visible}
      title="Change email address"
      className='register-text-style'
      onCancel={onCancel}
      footer={null}
      width={300}
      centered={true}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ marginTop: 20 }}
      >

        {/* Email Address and License Number */}
        <Form.Item
          label="Email Address : "
          name="emailAddress"
          rules={[
            { required: true, message: 'Please input your email address!' },
            { type: 'email', message: 'Please input a valid email address!' },
          ]}
        >
            <Input className='register-input-style'/>
        </Form.Item>
        <div  className='justify-items-center'>
            <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '200px'}}>
                Change
            </Button>
            </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};


export default ChangeEmailModal;